

/**
 * Component: AddonCard
 */

export default class AddonCard {

    constructor() {
     // selectors
        this.selectors = {
            card: '.addons-item'
        };
        this.$card = $(this.selectors.card);
        this.init();
    }

    init() {
        this.$card.on('click', '.cart-addon_radio', (event) => {
            event.stopPropagation();
            const radio = $(event.currentTarget);
            const button = radio.parent();

            if (button.hasClass('active')) {
                button.removeClass('active');
                radio.prop('checked', false);
            } else {
                button.addClass('active');
                radio.prop('checked', true);
            }
        });

        this.$card.on('click', (event) => {
            event.preventDefault();
            const targetNode = event.currentTarget;
            const radio = $(targetNode).find('input');

            radio.closest('.addons').find('.addons-item').removeClass('active');

            if (radio.prop('checked')) {
                radio.prop('checked', false);
            } else {
                targetNode.classList.add('active');
                radio.prop('checked', true);
            }
        });
    }
}
